import {GET_DATA_NEW_PLANHANDLE, SET_DATA_NEW_PLANHANDLE,GET_DATA_ACTION_LinkApi,GET_DATA_ACTION_LinkApibyid, GET_DATA_EMAIL_AZURE, GET_DATA_VALIDATE_DATE, GET_DATA_PLAN_BY_PASS } from '../actions/actionTypes'
import {RequertNewPlanHandleFaileAction, GetDataNewPlanHandleSuccessAction,
    GetDataLinkApiFailed,GetDataLinkApiSuccess,GetDataLinkApibyidSuccess,GetDataLinkApibyidFailed,
    IsResultAction, GetDataEmailAzureSuccessAction, RequestDataEmailAzureActionFailed, RequestDataValidateDateActionFailed, GetDataValidateDateSuccessAction, GetDataPlanByPassSuccessAction, RequestDataPlanByPassFailedAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataNew(action){
    try{
        const DataNew = yield Api.GetDataNewFromApi(action.id, action.planID);
        yield put(GetDataNewPlanHandleSuccessAction(DataNew))
    }catch(error){
        yield put(RequertNewPlanHandleFaileAction(error))
    }
}
export function* watchGetDataNew(){
    yield takeLatest(GET_DATA_NEW_PLANHANDLE, GetDataNew)
}

function* SetDataNew(action){
    try{
        const isResult = yield Api.SetDataNewFromApi(action.DataNew);
        yield put(IsResultAction(isResult))
    }catch(error){
        yield put(RequertNewPlanHandleFaileAction(error))
    }
}
export function* watchSetDataNew(){
    yield takeLatest(SET_DATA_NEW_PLANHANDLE, SetDataNew)
}

// getdataLinkapi
function* GetDataLinkApi(action){
    try{
        const DataLinkApi = yield Api.GetDataLinkApi(action);
        yield put(GetDataLinkApiSuccess(DataLinkApi))
    }catch(error){
        yield put(GetDataLinkApiFailed(error))
    }
}
export function* watchGetDataLinkApi(){
    yield takeLatest(GET_DATA_ACTION_LinkApi, GetDataLinkApi)
}

// getdataLinkapibyid
function* GetDataLinkApibyid(action){
    try{
        const DataLinkApibyid = yield Api.GetDataLinkApibyid(action);
        yield put(GetDataLinkApibyidSuccess(DataLinkApibyid))
    }catch(error){
        yield put(GetDataLinkApibyidFailed(error))
    }
}
export function* watchGetDataLinkApibyid(){
    yield takeLatest(GET_DATA_ACTION_LinkApibyid, GetDataLinkApibyid)
}

// get Azure Email Address

function* GetDataEmailAzureByName(action){
    try {
        const DataEmailAzure = yield Api.GetDataEmailAzureByName(action);
        yield put(GetDataEmailAzureSuccessAction(DataEmailAzure))
    } catch(error) {
        yield put(RequestDataEmailAzureActionFailed(error))
    }
}

export function* watchGetDataEmailAzureByName() {
    yield takeLatest(GET_DATA_EMAIL_AZURE, GetDataEmailAzureByName)
}

//Get Validate Date
function* GetDataValidateDate(action){
    try {
        const DataValidateDate = yield Api.GetDataValidateDate(action.DataValidate);
        yield put(GetDataValidateDateSuccessAction(DataValidateDate))
    } catch(error) {
        yield put(RequestDataValidateDateActionFailed(error))
    }
}

export function* watchGetDataValidateDate() {
    yield takeLatest(GET_DATA_VALIDATE_DATE, GetDataValidateDate)
}
//GetDataPlanByPass
function* GetDataPlanByPass(){
    try {
        const DataPlan = yield Api.GetDataPlanByPass();
        yield put(GetDataPlanByPassSuccessAction(DataPlan))
    } catch(error) {
        yield put(RequestDataPlanByPassFailedAction(error))
    }
}

export function* watchGetDataPlanByPass() {
    yield takeLatest(GET_DATA_PLAN_BY_PASS, GetDataPlanByPass)
}